import type { QueryParams } from './DefaultQueryFormatter'
import DefaultQueryFormatter from './DefaultQueryFormatter'

export default class FeaturedTopicsQueryFormatter extends DefaultQueryFormatter {
  override getDefaultFilters(_params: QueryParams = {}): {
    states: string[]
    audiences: string[]
    topics: string[]
  } {
    return {
      states: [],
      audiences: [],
      topics: [],
    }
  }
}
